import { useRef } from "react";
import Popover from "../popover/popover";
import { useAppSelector } from "../../../../../redux/hooks";
import { conditions } from "../../../../../helpers";
import { ConditionName, IMultiLiveDialogProps } from "../../../../../interfaces";
import useOnClickOutside from "../../../../../helpers/hooks/useOnClickOutside";
import { alternativeLiveLog, sendFluentLog } from "../../../../../logs";
import CloseIcon from "../../icon-components/closeIcon";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const PlayerCard = dynamic(() => import("../playerCard/playerCard"));

const MultiLiveDialog = ({ status, onClose }: IMultiLiveDialogProps) => {

    const { params, multiLives } = useAppSelector(({ videoData: { params, multiLives, isComplexPortrait } }) => ({ params, multiLives, isComplexPortrait }), shallowEqual);

    const multiLiveRef = useRef<any>();

    const handleBannerSrc = (live: any) => {
        let src: string = "";

        if (live.alternative_banner) src = live.alternative_banner;
        else if (live.banner) src = live.banner;

        return src;
    }

    useOnClickOutside(multiLiveRef, () => onClose(false))

    const multiLivesPopoverContent = conditions(ConditionName.isComplexPortrait) ? (
        <div className="pl-flex pl-flex-col pl-gap-3 pl-mx-3">
            {
                multiLives.length > 0 && multiLives.map((live: any, index: number) => (
                    <div key={live.id} className="pl-w-full pl-flex" style={{ height: 80 }}>
                        <PlayerCard 
                            tags={live.tag} 
                            id={live.id}
                            userId={live.user_id}
                            width={142} 
                            height={80} 
                            src={index === 0 ? "" : handleBannerSrc(live)} 
                            isVideo={index === 0} 
                            type="live" 
                            title={live.title} 
                            viewers={live.viewers} 
                            onClick={() => sendFluentLog(alternativeLiveLog(live.user_id))}
                        />
                    </div>
                ))
            }
        </div>
    ) : (
        <div className="pl-w-screen pl-h-screen pl-flex pl-flex-col pl-items-start pl-justify-between pl-px-3 pl-pt-[15px]">
            <div className="pl-flex pl-gap-3 pl-text-white">
                <CloseIcon className="pl-cursor-pointer pl-w-6 pl-h-6 pl-stroke-dark-5" onClick={() => onClose(false)} />
                <p className="pl-text-[16px] pl-font-bold">پخش زنده های دیگر</p>
            </div>
            <div className="pl-w-auto pl-overflow-auto pl-flex pl-gap-4 no-scrollbar pl-mb-3" ref={multiLiveRef}>
                {multiLives.length > 0 && multiLives.map((live: any, index: number) => 
                    <div key={live.id} className="pl-w-full pl-flex pl-cursor-pointer" style={{ height: "100%" }}>
                        <PlayerCard 
                            tags={live.tag} 
                            id={live.id}
                            userId={live.user_id}
                            isMultiLive={true} 
                            key={live.id} 
                            width={240} 
                            height={135} 
                            src={index === 0 ? "" : handleBannerSrc(live)} 
                            isVideo={index === 0} 
                            type="live" 
                            title={live.title} 
                            onClick={() => sendFluentLog(alternativeLiveLog(live.user_id))}
                        />
                    </div>
                )}
            </div>
        </div>
    )

    return (
        <Popover
            status={status}
            onClose={onClose}
            styles={{ width: "100%" }}
            isFullHeight={conditions(ConditionName.isComplexPortrait)}
            isHeader={conditions(ConditionName.isComplexPortrait)}
            headerTitle={conditions(ConditionName.isComplexPortrait) ? "پخش زنده های دیگر" : ""}
            type="modal"
            isHasCatchUpLineOnTop={conditions(ConditionName.isComplexPortrait)}
            classNames={`${conditions(ConditionName.isComplexPortrait) && params.theme === "light" ? "!pl-bg-white" : "!pl-bg-black/[0.7]"}`}
        >
            {multiLivesPopoverContent}
        </Popover>
    )
}

export default MultiLiveDialog;